import React from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import * as action from '../action';
import * as c from '../constant';

function BPLSContent({ transactionInfo, taxpayer }) {
  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const formatPeriod = (data) => {
    return data
      ? data.toString()
        .replace('1', '1st quarter')
        .replace('2', '2nd quarter')
        .replace('3', '3rd quarter')
        .replace('4', '4th quarter')
      : '---';
  };

  return (
    <>
      <div className="card-section-content container-fluid citizen-tabs">
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {getInitials(`${_.get(taxpayer, 'business_name')}`)}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'business_name') || '-'}`}
                      </h1>
                    </div>
                  </div>
                  <TransactionInformation
                    module="bpls"
                    transactionInfo={transactionInfo}
                    taxpayer={taxpayer}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-1 pb-1 px-3">
            <div className="col-12">
              <table className="transaction-table table table-borderless table-sm table-striped table-hover">
                <tbody>
                  <tr>
                    <td className="text-dark" width="250">
                      Business Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'business_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      BIN
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{(_.get(taxpayer, 'bin') || '--').toUpperCase()}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      From
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{formatPeriod(_.get(taxpayer, 'qtr_from'))}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      To
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{formatPeriod(_.get(taxpayer, 'qtr_to'))}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Date
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {_.get(taxpayer, 'date')
                          ? moment(
                            `${_.get(taxpayer, 'date')}`
                          ).format('MMM DD, YYYY')
                          : '--'}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

BPLSContent.propTypes = {
  // selectedTransaction: PropTypes.string.isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  // approveTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  taxpayerProfile:
    _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(BPLSContent);
